import { GreenToRedPositionsLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/GreenToRedPositionsLine';
import { GreenToRedPositionsTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/GreenToRedPositionsTacticPanel';
import { AddGreenToRedPositionsTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddGreenToRedPositionsTacticPanel';
import { GreenToRedPositionsWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/GreenToRedPositionsModule/wrapper/GreenToRedPositionsWrapper';
import { GreenToRedPositionsDocs } from '../../../../components/forms/tradeplans/documentation/GreenToRedDocumentation';
import GreenToRedPositionsModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/GreenToRedPositionsModule';
import { GreenToRedPositionsData } from './greenToRedPositionsData';
import { validateGreenToRedPositions } from './validateGreenToRedPositions';

export const GreenToRedPositions = {
  //data class
  dataStore: GreenToRedPositionsData,

  //string constants
  name: 'GREEN_TO_RED_POSITIONS',
  tacticLabel: 'Green to Red Positions',
  addTacticLabel: 'Add Green to Red Positions',
  category: 'Exit',

  // components
  tradePlanFormModule: GreenToRedPositionsModule,
  tacticPanel: GreenToRedPositionsTacticPanel,
  addTacticPanel: AddGreenToRedPositionsTacticPanel,
  wrapper: GreenToRedPositionsWrapper,
  chartSoftOrderComponent: GreenToRedPositionsLine,
  documentation: GreenToRedPositionsDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateGreenToRedPositions,
};
